export default "__VITE_ASSET__633616b0__"